import React from 'react';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {
        const selectedSearchValues = this.props.searchData;
        const reconciliationRegisterdData = this.props.reconciliationRegisterdData || [];
        const bankReconciliationDetails = this.props.bankReconciliationDetails;
        const bankAccount = this.props.bankData || {};

        const getStatusText = (reconsilationStatus) => {
            if (reconsilationStatus === 3) return 'Approved';
            else if (reconsilationStatus === 2) return 'Pending Approval';
            return '-';
        };

        const totalCredit = reconciliationRegisterdData.reduce((sum, data) => sum + (data.credit || 0), 0);
        const totalDebit = reconciliationRegisterdData.reduce((sum, data) => sum + (data.debit || 0), 0);

        return (
            <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
                <div style={{ width: '1093px', height: 'auto', padding: '20px', marginBottom: '2rem', backgroundColor: 'white' }}>
                    <br />
                    <h2><center><u>Bank Reconciliation History Report</u></center></h2>
                    <h3>
                        <center>{'Group : ' + (selectedSearchValues.groupName || '')}</center>
                        <center>{'Factory : ' + (selectedSearchValues.factoryName || '')}</center>
                        <center>{'Month: ' + bankReconciliationDetails.year + '-' + bankReconciliationDetails.month}</center>
                        <center>{'Bank Account: ' + (bankAccount.ledgerAccountName || 'N/A')}</center>
                    </h3>
                    <div>&nbsp;</div>
                    <div>
                        <Box minWidth={1050}>
                            <TableContainer style={{ backgroundColor: 'white' }}>
                                <Table aria-label="bank reconciliation table" style={{ backgroundColor: 'white', border: '1px solid #000', borderCollapse: 'collapse' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left" style={{ backgroundColor: 'white', color: 'black', border: '1px solid #000', fontWeight: 'bold' }}>Date</TableCell>
                                            <TableCell align="left" style={{ backgroundColor: 'white', color: 'black', border: '1px solid #000', fontWeight: 'bold' }}>Voucher Number</TableCell>
                                            <TableCell align="left" style={{ backgroundColor: 'white', color: 'black', border: '1px solid #000', fontWeight: 'bold' }}>Description</TableCell>
                                            <TableCell align="left" style={{ backgroundColor: 'white', color: 'black', border: '1px solid #000', fontWeight: 'bold' }}>Cheque Number</TableCell>
                                            <TableCell align="right" style={{ backgroundColor: 'white', color: 'black', border: '1px solid #000', fontWeight: 'bold' }}>Credit</TableCell>
                                            <TableCell align="right" style={{ backgroundColor: 'white', color: 'black', border: '1px solid #000', fontWeight: 'bold' }}>Debit</TableCell>
                                            <TableCell align="left" style={{ backgroundColor: 'white', color: 'black', border: '1px solid #000', fontWeight: 'bold' }}>Due Date</TableCell>
                                            <TableCell align="left" style={{ backgroundColor: 'white', color: 'black', border: '1px solid #000', fontWeight: 'bold' }}>Realized Date</TableCell>
                                            <TableCell align="left" style={{ backgroundColor: 'white', color: 'black', border: '1px solid #000', fontWeight: 'bold' }}>Status</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {reconciliationRegisterdData.map((data, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{data.date ? data.date.split('T')[0] : '-'}</TableCell>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{data.referenceNumber || '-'}</TableCell>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{data.description || '-'}</TableCell>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{data.chequeNumber || '-'}</TableCell>
                                                <TableCell align="right" style={{ border: '1px solid #000' }}>{data.credit ? data.credit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}</TableCell>
                                                <TableCell align="right" style={{ border: '1px solid #000' }}>{data.debit ? data.debit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'}</TableCell>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{data.dueDate ? data.dueDate.split('T')[0] : '-'}</TableCell>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{data.realizedDate ? data.realizedDate.split('T')[0] : '-'}</TableCell>
                                                <TableCell align="left" style={{ border: '1px solid #000' }}>{getStatusText(data.reconsilationStatus)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell align="left" style={{ border: '1px solid #000', fontWeight: 'bold' }} colSpan={4}>TOTAL</TableCell>
                                            <TableCell align="right" style={{ border: '1px solid #000', fontWeight: 'bold' }}>
                                                {totalCredit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell align="right" style={{ border: '1px solid #000', fontWeight: 'bold' }}>
                                                {totalDebit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                            <TableCell style={{ border: '1px solid #000' }} colSpan={3}></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </div>
                </div>
            </div>
        );
    }
}
